// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "rejectMessage-1jNeX";
var _4 = "radio-poN7w";
var _5 = "label-2YrbV";
var _6 = "checked-3Fv6J";
var _7 = "container-2UriH";
var _8 = "title-3Atvu";
var _9 = "icon-2PjDg";
var _a = "segments-39Shw";
var _b = "segment-2zraH";
var _c = "disabled-1a79r";
export { _1 as "__esModule", _2 as "mobile", _3 as "rejectMessage", _4 as "radio", _5 as "label", _6 as "checked", _7 as "container", _8 as "title", _9 as "icon", _a as "segments", _b as "segment", _c as "disabled" }
export default { "__esModule": _1, "mobile": _2, "rejectMessage": _3, "radio": _4, "label": _5, "checked": _6, "container": _7, "title": _8, "icon": _9, "segments": _a, "segment": _b, "disabled": _c }
